<template>
  <div class="imgListBan">
    <div class="g-box">
      <div class="imgListBan-hd">
        <template v-if="info && Object.keys(info).length">
          <div
            class="hd-img"
            :style="{
              backgroundImage: 'url(' + info.image + ')'
            }"
          ></div>
          <div class="hd-cont">
            <div class="hd-cap">{{ info.title }}</div>
            <div class="hd-tit">{{ info.tips }}</div>
            <div class="hd-text" v-html="info.content"></div>
          </div>
        </template>
      </div>
      <!-- Swiper -->
      <div class="imgListBan-bd">
        <div class="ban swiper-container">
          <div class="swiper-wrapper">
            <div
              v-for="(item, index) in list"
              :key="index"
              :index="index"
              class="swiper-slide m-h"
              :class="{ on: ind === index }"
              :style="{
                backgroundImage: 'url(' + item.image + ')'
              }"
            ></div>
          </div>
        </div>
        <div class="ban-sys">
          <div class="ban-prev"></div>
          <div class="ban-next"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import Swiper from "swiper";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      info: {},
      ind: 0,
      swiper: "",
      pageSize: 10000000
    };
  },
  components: {},
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      await this.getList();
      if (!this.list.length) return;
      this.swiper = new Swiper(".imgListBan-bd .ban.swiper-container", {
        slidesPerView: 4,
        spaceBetween: 14,
        loop: false,
        navigation: {
          nextEl: ".imgListBan-bd .ban-next",
          prevEl: ".imgListBan-bd .ban-prev"
        },
        on: {
          init: () => {
            this.changeInfo();
          },
          click: el => {
            this.ind = Number(el.target.getAttribute("index"));
            this.changeInfo();
          }
        }
      });
    },
    async changeInfo() {
      this.info = await this.getAjaxInfo(this.list[this.ind].id);
    }
  }
};
</script>
<style lang="less">
.imgListBan {
  padding: 120px 0;
}
.imgListBan-hd {
  display: flex;
  height: 388px;
  .hd-img {
    flex-shrink: 0;
    width: 582px;
    height: 388px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .hd-cont {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-left: 50px;
    padding-top: 18px;
  }
  .hd-cap {
    color: #282828;
    font-size: 20px;
    flex-shrink: 0;
  }
  .hd-tit {
    color: #979797;
    margin-top: 10px;
    flex-shrink: 0;
  }
  .hd-text {
    color: #979797;
    font-size: 16px;
    margin-top: 32px;
    line-height: 26px;
    flex-grow: 1;
    overflow: auto;
  }
}
.imgListBan-bd {
  margin-top: 97px;
  display: flex;
  .ban {
    height: 135px;
    width: 965px;
    margin: 0;
    &.swiper-container {
      .swiper-wrapper {
        .swiper-slide {
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          box-sizing: border-box;
          border: 2px solid rgba(141, 141, 141, 1);
          &.on {
            border-width: 4px;
            border-color: #fd8f5d;
          }
        }
      }
    }
  }
  .ban-sys {
    margin-top: auto;
    margin-left: auto;
    display: flex;
  }
  .ban-prev,
  .ban-next {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 36px;
    border: 2px solid rgba(82, 151, 224, 1);
    cursor: pointer;
    outline: none;
    background-repeat: no-repeat;
    background-position: center;
    &:hover {
      background-color: #5297e0;
    }
    &.swiper-button-disabled {
      border-color: #ddd;
      cursor: no-drop;
      &:hover {
        background-color: transparent;
      }
    }
  }
  .ban-prev {
    background-image: url("../../assets/img/ico_20.png");
    &:hover {
      background-image: url("../../assets/img/ico_18.png");
    }
    &.swiper-button-disabled {
      &:hover {
        background-image: url("../../assets/img/ico_20.png");
      }
    }
  }
  .ban-next {
    background-image: url("../../assets/img/ico_21.png");
    margin-left: 40px;
    &:hover {
      background-image: url("../../assets/img/ico_19.png");
    }
    &.swiper-button-disabled {
      &:hover {
        background-image: url("../../assets/img/ico_21.png");
      }
    }
  }
}
</style>
